import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-47b637e4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teacher-card-container"
};
const _hoisted_2 = {
  class: "teacher-info-wrapper"
};
const _hoisted_3 = {
  class: "teacher-info"
};
const _hoisted_4 = {
  class: "teacher-name"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["src"];
import { getContentText } from '@/plugins/utils';
export default {
  props: {
    teacherData: {
      type: Object,
      default: () => {}
    }
  },

  setup(__props) {
    const props = __props;
    const {
      appContext
    } = getCurrentInstance();
    const data = computed(() => props.teacherData);
    const defaultCoverImg = inject('defaultImg');
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "teacher-card",
        onClick: _cache[0] || (_cache[0] = (...args) => _ctx.openDetail && _ctx.openDetail(...args))
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_unref(data).news_name), 1), _createElementVNode("div", {
        innerHTML: _unref(getContentText)(_unref(data).context),
        class: "teacher-organ"
      }, null, 8, _hoisted_5)])]), _createElementVNode("img", {
        class: "card-img",
        src: _unref(data).cover_url || _unref(defaultCoverImg),
        alt: ""
      }, null, 8, _hoisted_6)])]);
    };
  }

};